export default "__VITE_ASSET__4ef1440a__"